.pf-v5-c-radio {
  --pf-v5-c-radio--GridGap: var(--pf-v5-global--spacer--xs) var(--pf-v5-global--spacer--sm);
  --pf-v5-c-radio__label--disabled--Color: var(--pf-v5-global--disabled-color--100);
  --pf-v5-c-radio__label--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-radio__label--FontWeight: var(--pf-v5-global--FontWeight--normal);
  --pf-v5-c-radio__label--FontSize: var(--pf-v5-global--FontSize--md);
  --pf-v5-c-radio__label--LineHeight: var(--pf-v5-global--LineHeight--sm);
  --pf-v5-c-radio__input--Height: var(--pf-v5-c-radio__label--FontSize);
  --pf-v5-c-radio__input--MarginTop: calc(((var(--pf-v5-c-radio__label--FontSize) * var(--pf-v5-c-radio__label--LineHeight)) - var(--pf-v5-c-radio__input--Height)) / 2);
  --pf-v5-c-radio__input--first-child--MarginLeft: 0.0625rem;
  --pf-v5-c-radio__input--last-child--MarginRight: 0.0625rem;
  --pf-v5-c-radio__description--FontSize: var(--pf-v5-global--FontSize--sm);
  --pf-v5-c-radio__description--Color: var(--pf-v5-global--Color--200);
  --pf-v5-c-radio__body--MarginTop: var(--pf-v5-global--spacer--sm);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: var(--pf-v5-c-radio--GridGap);
}
.pf-v5-c-radio.pf-m-standalone {
  --pf-v5-c-radio--GridGap: 0;
  --pf-v5-c-radio__input--Height: auto;
  --pf-v5-c-radio__input--MarginTop: 0;
  display: inline-grid;
  line-height: 1;
}

.pf-v5-c-radio__label {
  font-size: var(--pf-v5-c-radio__label--FontSize);
  font-weight: var(--pf-v5-c-radio__label--FontWeight);
  line-height: var(--pf-v5-c-radio__label--LineHeight);
  color: var(--pf-v5-c-radio__label--Color);
}

.pf-v5-c-radio__input {
  height: var(--pf-v5-c-radio__input--Height);
  margin-top: var(--pf-v5-c-radio__input--MarginTop);
}
.pf-v5-c-radio__input:first-child {
  margin-left: var(--pf-v5-c-radio__input--first-child--MarginLeft);
}
.pf-v5-c-radio__input:last-child {
  margin-right: var(--pf-v5-c-radio__input--last-child--MarginRight);
}

.pf-v5-c-radio__description {
  grid-column: 2;
  font-size: var(--pf-v5-c-radio__description--FontSize);
  color: var(--pf-v5-c-radio__description--Color);
}

.pf-v5-c-radio__body {
  grid-column: 2;
  margin-top: var(--pf-v5-c-radio__body--MarginTop);
}

.pf-v5-c-radio__label,
.pf-v5-c-radio__input {
  justify-self: start;
}
label.pf-v5-c-radio, .pf-v5-c-radio__label,
.pf-v5-c-radio__input {
  cursor: pointer;
}

.pf-v5-c-radio__label:disabled, .pf-v5-c-radio__label.pf-m-disabled,
.pf-v5-c-radio__input:disabled,
.pf-v5-c-radio__input.pf-m-disabled {
  --pf-v5-c-radio__label--Color: var(--pf-v5-c-radio__label--disabled--Color);
  cursor: not-allowed;
}